<ion-content forceOverscroll="false" color="gray">
  <ion-toolbar mode="md" color="gradient-blue-demon" class="backgroud-gradient">
  </ion-toolbar>

  <ion-img [src]="'Icons.reset-user' | translate | assetsUrl" class="reset-user"></ion-img>

  <ion-grid fixed class="grid-info">
    <ion-list
      lines="none"
      mode="md"
      class="ion-no-padding ion-no-margin list-info"
    >
      <ion-item lines="none" mode="md" color="gray" class="ion-text-center">
        <ion-label color="status-icon-enable" class="register-your-account-new">
          {{ 'Titles.register-your-account-new' | translate }}
        </ion-label>
      </ion-item>

      <ion-item lines="none" mode="md" color="gray" class="ion-text-center">
        <ion-label color="grayDemon" class="reset-account-create-with-data">
          {{ 'Labels.reset-account-create-with-data' | translate }}
        </ion-label>
      </ion-item>

      <ion-item lines="none" mode="md" color="gray">
        <ion-button
          fill="solid"
          color="tpcta"
          size="deault"
          (click)="onClose()"
          class="button-close"
        >
          <ion-label class="enderstood">
            {{ 'Buttons.enderstood' | translate }}
          </ion-label>
        </ion-button>
      </ion-item>
    </ion-list>
  </ion-grid>
</ion-content>
